import { observable } from 'mobx';
import {
  PAYMENT_ERRORS,
  GENERAL,
} from '../constants/Errors';
import { diContainer, serviceNames } from '../diContainer/diContainer';
import UserPreferencesRepository from '../repositories/UserPreferencesRepository';
import UserPreferences from '../domain/entities/UserPreferences/UserPreferences';
import NotificationsCollection from '../domain/entities/Notification/NotificationsCollection';
import { NOTIFICATION_TYPE } from '../constants/Notifications';

class SavePrivacyPolicyUseCase {
  private acceptState: boolean;

  private userPreferencesRepository: UserPreferencesRepository;

  private userPreferences: UserPreferences;

  @observable notificationsCollection: NotificationsCollection;

  constructor(acceptState: boolean) {
    this.acceptState = acceptState;
    this.userPreferencesRepository = diContainer.get(serviceNames.userPreferencesRepository);
    this.userPreferences = diContainer.get(serviceNames.userPreferences);
    this.notificationsCollection = diContainer.get(serviceNames.notificationsCollection);
  }

  public async execute(): Promise<void> {
    try {
      this.userPreferences.setAcceptedPrivacyPolicy(this.acceptState);
      if (this.acceptState) {
        this.userPreferences.setRequirePrivacyPolicy(false);
        this.notificationsCollection.clearNotificationByKey(PAYMENT_ERRORS.REQUIRED_PRIVACY_POLICY);
      }
      await this.userPreferencesRepository.updateAcceptedState(this.userPreferences);
    } catch (e) {
      this.notificationsCollection.addNotification({
        key: GENERAL.GENERIC,
        type: NOTIFICATION_TYPE.DANGER,
      });
      this.userPreferences.setAcceptedPrivacyPolicy(!this.acceptState);
    }
  }
}

export default SavePrivacyPolicyUseCase;
